import { memo, Fragment } from 'react';
import Day from './Day';
import { useCalendar } from '../../Context';
import { deriveDays } from '../../utils';
const Week = memo((props) => {
    const { date } = props;
    const { weekStartsOn } = useCalendar();
    return (<Fragment>
      {deriveDays({ date, weekStartsOn }).map((day) => (<Day key={day.toString()} date={day}/>))}
    </Fragment>);
});
Week.displayName = 'Week';
export default Week;
